import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ContaReceber } from './contareceber';
import { ContaCorrenteService } from 'src/app/service/contaCorrente.service';
import { ContaCorrente } from '../conta-corrente/contacorrente';
import { ContaReceberService } from 'src/app/service/contaReceber.service';
import { ClientService } from 'src/app/service/client.service';
import { FornecedorService } from 'src/app/service/fornecedor.service';
import { ColaboradorService } from 'src/app/service/colaborador.service';
import { SegmentoService } from 'src/app/service/segmento.service';
import { Segmento } from '../segmento/segmento';
import { BaixaLinha, CONFIG_CONTA_RECEBER, ContaFinanceiraUiConfig } from 'src/app/util/conta-financeira/conta-financeira.model';
import {
  calcValorAcrescimo,
  calcValorPago,
  calcValorRestante,
  labelStatusPagamento,
  montarBaixasLista,
} from 'src/app/util/conta-financeira/conta-financeira.util';
import { isContaFinanceiraAberta, parseValorMonetario } from 'src/app/util/conta-financeira/conta-financeira.helpers';
import { formatarDataApi, parseDataApi } from 'src/app/util/date-format.util';
import { abrirAnexoVisualizar } from 'src/app/util/conta-financeira/anexo-visualizar.util';

interface Pagador {
  id: number;
  razaoSocial: string;
}

@Component({
  selector: 'app-conta-receber-form',
  templateUrl: './conta-receber-form.component.html',
  styleUrls: ['./conta-receber.component.scss']
})
export class ContaReceberFormComponent implements OnInit {

  formulario: FormGroup;
  baixaForm: FormGroup;
  mensagemErros: String[] = [];
  contasCorrentes: ContaCorrente[] = [];
  segmentos: Segmento[] = [];
  myControl = new FormControl('');
  pagadoresLista: Pagador[] = [];
  pagador: Pagador;
  bloquearCampoEdicao: boolean;

  arquivoBaixa: File | null = null;
  nomeArquivoBaixaSelecionado = '';
  arquivoFatura: File | null = null;
  nomeArquivoFaturaSelecionado = '';
  possuiAnexoFatura = false;
  possuiAnexoBaixa = false;
  nomeArquivoFaturaSalvo = '';
  nomeArquivoBaixaSalvo = '';
  config: ContaFinanceiraUiConfig = CONFIG_CONTA_RECEBER;
  valorBaixa: number | null = null;
  valorAcrescimo = 0;
  valorPago = 0;
  valorRestante = 0;
  statusPagamento = 'A RECEBER';
  diasAtraso = 0;
  jurosCalculado = 0;
  multaCalculada = 0;
  totalAtualizado = 0;
  baixas: BaixaLinha[] = [];
  private situacaoDescricaoAtual = '';

  // Auditoria / regeneração de cobrança
  @ViewChild('dialogRegerar') dialogRegerar!: TemplateRef<any>;
  private valorOriginal: number | null = null;
  private totalOriginal: number | null = null;
  private possuiCobrancaOriginal = false;
  valorAlteradoPor: string | null = null;
  valorAlteradoEm: string | null = null;

  constructor(
    private contaReceberService: ContaReceberService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private clientService: ClientService,
    private fornecedorService: FornecedorService,
    private colaboradorService: ColaboradorService,
    private contaCorrenteService: ContaCorrenteService,
    private segmentoService: SegmentoService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.pagador = { id: 0, razaoSocial: '' };
    this.montarFormulario();
    this.montarBaixaForm();
    this.carregarContasCorrentes();
    this.carregarSegmentos();
    this.myControl = new FormControl(
      '',
      [
        Validators.required,
        this.validateSelection()
      ]
    );

    this.myControl.valueChanges.subscribe(value => {
      this.handlePagadorChange(value);
    });

    this.formulario.get('tipoPagador')?.valueChanges.subscribe(() => {
      this.listarPagador();
    });

    this.listarCliente();
    this.formulario.valueChanges.subscribe(() => this.atualizarResumoFinanceiro());
    this.atualizarResumoFinanceiro();

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregarEdicao(+id);
    }
  }

  voltarConsulta() {
    this.router.navigate(['/contaReceber/consulta']);
  }

  montarFormulario() {
    this.bloquearCampoEdicao = false;
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      valor: [null, [Validators.required]],
      juros: [null, Validators.nullValidator],
      multa: [null, Validators.nullValidator],
      desconto: [null, Validators.nullValidator],
      total: [null, Validators.nullValidator],
      pagador: [null, Validators.nullValidator],
      tipoPagador: [null, Validators.nullValidator],
      dtVencimento: [null, Validators.nullValidator],
      dtPagamento: [null, Validators.nullValidator],
      parcela: ['1', Validators.required],
      formaCobranca: ['MANUAL', Validators.required],
      contaCorrenteId: [null],
      segmentoId: [null],
      pagamento: [null, Validators.nullValidator],
      situacao: ['A_RECEBER'],
      observacao: [null, Validators.nullValidator],
      descricao: [null],
      nrDocumento: [null, Validators.nullValidator],
      codigoBarras: [null, Validators.nullValidator],
      nossoNumero: [null],
      linhaDigitavel: [null],
      statusCobrancaSicoob: [null],
      mensagemCobrancaSicoob: [null],
      urlBoletoPdf: [null],
      txidPix: [null],
      pixCopiaECola: [null],
    });

    this.formulario.get('pagador')?.valueChanges.subscribe(value => {
      if (this.myControl.value !== value) {
        this.myControl.setValue(value, { emitEvent: false });
      }
    });
  }

  submit() {
    if (this.formulario.invalid || this.myControl.invalid) {
      this.snackBar.open('Por favor, preencha todos os campos obrigatórios corretamente.', 'ERRO', { duration: 2000 });
      return;
    }

    const formValues = this.formulario.getRawValue();
    let clienteId: number | null = null;
    let fornecedorId: number | null = null;
    let colaboradorId: number | null = null;
    const tipo = formValues.tipoPagador;
    const pagadorSelecionado = this.pagador;

    if (!pagadorSelecionado?.id) {
      this.snackBar.open('Selecione o pagador na lista.', 'ERRO', { duration: 2000 });
      return;
    }
    if (tipo === 'CLIENTE') {
      clienteId = pagadorSelecionado.id;
    } else if (tipo === 'FORNECEDOR') {
      fornecedorId = pagadorSelecionado.id;
    } else if (tipo === 'COLABORADOR') {
      colaboradorId = pagadorSelecionado.id;
    }
    if (['BOLETO', 'PIX'].includes(formValues.formaCobranca) && tipo !== 'CLIENTE') {
      this.snackBar.open('Boleto e PIX exigem pagador do tipo CLIENTE com CPF/CNPJ.', 'ERRO', { duration: 3000 });
      return;
    }
    if (['BOLETO', 'PIX'].includes(formValues.formaCobranca) && !formValues.contaCorrenteId) {
      this.snackBar.open('Selecione a conta corrente para gerar a cobrança.', 'ERRO', { duration: 3000 });
      return;
    }

    const conta: ContaReceber = new ContaReceber(
      formValues.id,
      formValues.valor,
      formValues.juros,
      formValues.multa,
      formValues.desconto,
      formValues.total,
      formatarDataApi(formValues.dtVencimento),
      null,
      null,
      formValues.parcela,
      null,
      'A_RECEBER',
      formValues.observacao,
      formValues.descricao,
      formValues.nrDocumento,
      formValues.codigoBarras,
      tipo,
      tipo,
      '',
      clienteId,
      fornecedorId,
      formValues.formaCobranca || 'MANUAL'
    );
    conta.contaCorrenteId = formValues.contaCorrenteId ?? null;
    conta.segmentoId = formValues.segmentoId ?? null;
    conta.colaboradorId = colaboradorId;

    const aoSucesso = (mensagem: string, contaSalva?: ContaReceber) => {
      if (contaSalva?.statusCobrancaSicoob === 'ERRO' && contaSalva.mensagemCobrancaSicoob) {
        this.snackBar.open('Conta salva. ' + contaSalva.mensagemCobrancaSicoob, 'Cobrança', { duration: 6000 });
      } else {
        this.snackBar.open(mensagem, 'Sucesso', { duration: 2000 });
      }
      const finalizar = () => { };
      if (contaSalva?.id) {
        this.formulario.patchValue({ id: contaSalva.id, situacao: contaSalva.situacao ?? 'A_RECEBER' });
        this.bloquearCampoEdicao = true;
        this.patchDadosCobranca(contaSalva);
        this.aplicarEncargos(contaSalva);
        this.baixaForm.patchValue({
          valor: this.totalAtualizado || contaSalva.total,
          dataPagamento: new Date(),
        });
        this.atualizarMetadadosAnexos(contaSalva);
        this.valorOriginal = contaSalva.valor != null ? Number(contaSalva.valor) : this.valorOriginal;
        this.totalOriginal = contaSalva.total != null ? Number(contaSalva.total) : this.totalOriginal;
        const formaAtual = contaSalva.formaCobranca ?? 'MANUAL';
        this.possuiCobrancaOriginal = (formaAtual === 'PIX' || formaAtual === 'BOLETO')
          && !!(contaSalva.qrCodePix || contaSalva.linhaDigitavel || contaSalva.pixCopiaECola);
        this.valorAlteradoPor = contaSalva.valorAlteradoPor ?? this.valorAlteradoPor;
        this.valorAlteradoEm = contaSalva.valorAlteradoEm ?? this.valorAlteradoEm;
        if (this.arquivoFatura) {
          this.contaReceberService.anexarFatura(contaSalva.id, this.arquivoFatura).subscribe((res) => {
            this.atualizarMetadadosAnexos(res);
            this.arquivoFatura = null;
            this.nomeArquivoFaturaSelecionado = '';
            finalizar();
          }, () => this.snackBar.open('Conta salva, mas falhou ao anexar fatura.', 'ERRO', { duration: 3000 }));
        } else {
          finalizar();
        }
      } else {
        this.limparFormulario();
        finalizar();
      }
    };

    if (formValues.id) {
      const executarUpdate = () => {
        this.contaReceberService.update(conta).subscribe(resposta => {
          aoSucesso('Conta à Receber alterada com sucesso!', resposta);
        }, errorResponse => {
          this.snackBar.open(errorResponse.error?.message ?? 'Erro ao alterar conta.', 'ERRO', { duration: 2000 });
        });
      };

      if (this.valorFoiAlterado(formValues) && this.possuiCobrancaOriginal) {
        this.dialog.open(this.dialogRegerar, { width: '480px' }).afterClosed().subscribe(confirmou => {
          if (!confirmou) {
            return;
          }
          conta.regenerarCobranca = true;
          conta.alteradoPor = localStorage.getItem('usuarioLogado') || 'Sistema';
          executarUpdate();
        });
      } else {
        executarUpdate();
      }
    } else {
      this.contaReceberService.save(conta).subscribe(resposta => {
        aoSucesso('Conta à Receber salva com sucesso!', resposta);
      }, errorResponse => {
        this.snackBar.open(errorResponse.error?.message ?? 'Erro ao salvar conta.', 'ERRO', { duration: 2000 });
      });
    }
  }

  private valorFoiAlterado(formValues: any): boolean {
    const valorAtual = Number(formValues.valor) || 0;
    const totalAtual = Number(formValues.total) || 0;
    const valorOrig = Number(this.valorOriginal) || 0;
    const totalOrig = Number(this.totalOriginal) || 0;
    return valorAtual !== valorOrig || totalAtual !== totalOrig;
  }

  // ── Editar ────────────────────────────────────────────────────────────────────
  carregarEdicao(id: number) {
    this.contaReceberService.findClientById(id).subscribe((response) => {
      this.formulario.patchValue({
        id,
        valor: response.valor,
        juros: response.juros,
        multa: response.multa,
        desconto: response.desconto,
        total: response.total,
        dtVencimento: parseDataApi(response.dtVencimento),
        dtPagamento: response.dtRecebimento ?? response.dtPagamento,
        parcela: response.parcela,
        pagamento: response.pagamento,
        situacao: response.situacao,
        observacao: response.observacao,
        descricao: response.descricao,
        nrDocumento: response.nrDocumento,
        codigoBarras: response.codigoBarras,
        tipoPagador: response.tipoPagador ?? response.pagador,
        formaCobranca: response.formaCobranca ?? 'MANUAL',
        contaCorrenteId: response.contaCorrenteId ?? null,
        segmentoId: response.segmentoId ?? null,
      });
      this.patchDadosCobranca(response);
      this.atualizarMetadadosAnexos(response);

      this.valorOriginal = response.valor != null ? Number(response.valor) : null;
      this.totalOriginal = response.total != null ? Number(response.total) : null;
      const forma = response.formaCobranca ?? 'MANUAL';
      this.possuiCobrancaOriginal = (forma === 'PIX' || forma === 'BOLETO')
        && !!(response.qrCodePix || response.linhaDigitavel || response.pixCopiaECola);
      this.valorAlteradoPor = response.valorAlteradoPor ?? null;
      this.valorAlteradoEm = response.valorAlteradoEm ?? null;

      this.aplicarEncargos(response);
      this.baixaForm.patchValue({
        formaPagamento: response.pagamento || null,
        valor: this.totalAtualizado || response.total,
        dataPagamento: parseDataApi(response.dtRecebimento || response.dtPagamento) || new Date(),
      });

      const tipoPagador: string = String(response.tipoPagador ?? response.pagador ?? '');
      const razaoSocial: string = String(response.pagadorDescricao ?? '');

      // Carrega a lista do tipo correto e depois localiza o objeto completo
      const carregarERestaurar = (lista: Pagador[]) => {
        this.pagadoresLista = lista;
        const encontrado = lista.find(p =>
          p.razaoSocial?.toLowerCase().trim() === razaoSocial?.toLowerCase().trim()
        );
        if (encontrado) {
          // Define o objeto completo — displayFn vai exibir razaoSocial
          this.pagador = encontrado;
          this.myControl.setValue(encontrado, { emitEvent: false });
        } else {
          // Fallback: cria objeto parcial para ao menos exibir o nome
          this.pagador = { id: 0, razaoSocial };
          this.myControl.setValue(this.pagador, { emitEvent: false });
        }
      };

      if (tipoPagador === 'FORNECEDOR') {
        this.fornecedorService.listarFornecedor().subscribe((lista: Pagador[]) => carregarERestaurar(lista));
      } else if (tipoPagador === 'COLABORADOR') {
        this.colaboradorService.listarAtivos().subscribe(lista => carregarERestaurar(this.mapearColaboradores(lista)));
      } else {
        this.clientService.listarCliente().subscribe((lista: Pagador[]) => carregarERestaurar(lista));
      }
      // ─────────────────────────────────────────────────────────────────────────
    });

    this.bloquearCampoEdicao = true;
  }
  // ─────────────────────────────────────────────────────────────────────────────

  limparFormulario() {
    this.router.navigate(['/contaReceber/form']);
    this.formulario.reset({
      parcela: '1',
      formaCobranca: 'MANUAL',
      contaCorrenteId: null,
      situacao: 'A_RECEBER',
    });
    this.baixaForm?.reset({ dataPagamento: new Date() });
    this.myControl.setValue('');
    this.bloquearCampoEdicao = false;
    this.valorBaixa = null;
    this.arquivoBaixa = null;
    this.arquivoFatura = null;
    this.nomeArquivoBaixaSelecionado = '';
    this.nomeArquivoFaturaSelecionado = '';
    this.possuiAnexoFatura = false;
    this.possuiAnexoBaixa = false;
    this.situacaoDescricaoAtual = '';
    this.valorOriginal = null;
    this.totalOriginal = null;
    this.possuiCobrancaOriginal = false;
    this.valorAlteradoPor = null;
    this.valorAlteradoEm = null;
    this.patchDadosCobranca(null);
    this.atualizarResumoFinanceiro();
  }

  private patchDadosCobranca(conta: ContaReceber | null): void {
    this.formulario.patchValue({
      nossoNumero: conta?.nossoNumero ?? null,
      linhaDigitavel: conta?.linhaDigitavel ?? conta?.codigoBarras ?? null,
      statusCobrancaSicoob: conta?.statusCobrancaSicoob ?? null,
      mensagemCobrancaSicoob: conta?.mensagemCobrancaSicoob ?? null,
      urlBoletoPdf: conta?.urlBoletoPdf ?? null,
      txidPix: conta?.txidPix ?? null,
      pixCopiaECola: conta?.pixCopiaECola ?? null,
    });
  }

  carregarContasCorrentes() {
    this.contaCorrenteService.listar().subscribe(lista => {
      this.contasCorrentes = lista;
    });
  }

  carregarSegmentos() {
    this.segmentoService.listarAtivos().subscribe(lista => {
      this.segmentos = lista;
    });
  }

  atualizarResumoFinanceiro() {
    const fv = this.formulario?.value || {};
    this.valorAcrescimo = calcValorAcrescimo(fv.juros, fv.multa);
    this.valorPago = calcValorPago(fv.situacao, this.config, this.valorBaixa, fv.total);
    this.valorRestante = calcValorRestante(fv.total, this.valorPago);
    this.statusPagamento = labelStatusPagamento(fv.situacao, this.situacaoDescricaoAtual, this.config);
    this.baixas = montarBaixasLista({
      situacao: fv.situacao,
      pagamento: fv.pagamento,
      valorBaixa: this.valorBaixa,
      total: fv.total,
      dtPagamento: fv.dtPagamento,
      dtRecebimento: fv.dtPagamento,
      possuiAnexoBaixa: this.possuiAnexoBaixa,
      config: this.config,
    });
  }

  calcularValorTotal() {
    const fv = this.formulario.value;
    const total = (Number(fv.valor) || 0) - (Number(fv.desconto) || 0) + (Number(fv.juros) || 0) + (Number(fv.multa) || 0);
    this.formulario.controls.total.setValue(total, { emitEvent: false });
    this.atualizarResumoFinanceiro();
  }

  listarFornecedor() {
    this.fornecedorService.listarFornecedor().subscribe((response: Pagador[]) => {
      this.pagadoresLista = response;
      this.myControl.setValue('');
    });
  }

  listarCliente() {
    this.clientService.listarCliente().subscribe((response: any[]) => {
      this.pagadoresLista = this.filtrarClientesPorSegmento(response);
      this.myControl.setValue('');
    });
  }

  private filtrarClientesPorSegmento(clientes: any[]): Pagador[] {
    let lista = clientes ?? [];
    const segId = this.formulario.get('segmentoId')?.value;
    const segmento = this.segmentos.find(s => s.id === segId);
    const codigo = segmento?.codigo;
    if (codigo) {
      lista = lista.filter(c => Array.isArray(c.segmentos) && c.segmentos.includes(codigo));
    }
    return lista.map(c => ({ id: c.id, razaoSocial: c.razaoSocial }));
  }

  listarColaborador() {
    this.colaboradorService.listarAtivos().subscribe(lista => {
      this.pagadoresLista = this.mapearColaboradores(lista);
      this.myControl.setValue('');
    });
  }

  private mapearColaboradores(lista: any[]): Pagador[] {
    return (lista ?? []).map(c => ({ id: c.id, razaoSocial: c.nome }));
  }

  displayFn(pagador: Pagador | string): string {
    if (pagador && (pagador as Pagador).razaoSocial) {
      return (pagador as Pagador).razaoSocial;
    }
    if (typeof pagador === 'string') { return pagador; }
    return '';
  }

  handlePagadorChange(value: Pagador | string | null): void {
    if (typeof value === 'object' && value !== null && value.razaoSocial) {
      this.pagador = value;
      this.formulario.get('pagador')?.setValue(value.razaoSocial, { emitEvent: false });
    } else {
      this.pagador = null as unknown as Pagador;
      this.formulario.get('pagador')?.setValue(null, { emitEvent: false });
    }
  }

  listarPagador() {
    const tipoSelecionado = this.formulario.get('tipoPagador')?.value;
    this.pagadoresLista = [];
    this.myControl.setValue('');

    if (tipoSelecionado !== 'CLIENTE') {
      this.formulario.get('segmentoId')?.setValue(null, { emitEvent: false });
    }

    if (tipoSelecionado === 'FORNECEDOR') {
      this.listarFornecedor();
    } else if (tipoSelecionado === 'CLIENTE') {
      this.listarCliente();
    } else if (tipoSelecionado === 'COLABORADOR') {
      this.listarColaborador();
    }
  }

  private validateSelection(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value === null || value === '') { return null; }
      const isObject = typeof value === 'object' && value !== null && value.id;
      return isObject ? null : { invalidSelection: true };
    };
  }

  private aplicarEncargos(conta: ContaReceber | any) {
    this.diasAtraso = Number(conta?.diasAtraso ?? 0) || 0;
    this.jurosCalculado = Number(conta?.jurosCalculado ?? 0) || 0;
    this.multaCalculada = Number(conta?.multaCalculada ?? 0) || 0;
    this.totalAtualizado = Number(conta?.totalAtualizado ?? conta?.total ?? 0) || 0;

    // Conta vencida e em aberto: mostra os juros/multa calculados nos próprios campos
    // e atualiza o "Total A Receber" para refletir o valor com encargos.
    if (this.possuiEncargoAtraso && this.formulario) {
      this.formulario.patchValue({
        juros: this.jurosCalculado,
        multa: this.multaCalculada,
      }, { emitEvent: false });
      this.calcularValorTotal();
    }
  }

  get possuiEncargoAtraso(): boolean {
    return this.diasAtraso > 0 && (this.jurosCalculado > 0 || this.multaCalculada > 0);
  }

  montarBaixaForm() {
    this.baixaForm = this.formBilder.group({
      formaPagamento: [null, Validators.required],
      valor: [null],
      dataPagamento: [new Date(), Validators.required],
    });
  }

  contaAberta(): boolean {
    return isContaFinanceiraAberta(this.formulario?.value?.situacao, 'A_RECEBER');
  }

  onArquivoBaixa(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) { return; }
    this.arquivoBaixa = input.files[0];
    this.nomeArquivoBaixaSelecionado = this.arquivoBaixa.name;
    input.value = '';
  }

  onArquivoFatura(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) { return; }
    this.arquivoFatura = input.files[0];
    this.nomeArquivoFaturaSelecionado = this.arquivoFatura.name;
    input.value = '';
  }

  registrarBaixa() {
    const id = this.formulario.value.id;
    if (!id) {
      this.snackBar.open('Salve a conta antes de registrar a baixa.', 'ERRO', { duration: 2500 });
      return;
    }
    if (this.baixaForm.invalid) {
      this.snackBar.open('Informe a forma e a data do recebimento.', 'ERRO', { duration: 2000 });
      return;
    }
    if (!this.contaAberta()) {
      this.snackBar.open('Esta conta já está recebida.', 'ERRO', { duration: 2000 });
      return;
    }
    const b = this.baixaForm.value;
    const valor = parseValorMonetario(b.valor) ?? parseValorMonetario(this.formulario.value.total);
    this.contaReceberService.registrarBaixa(id, b.formaPagamento, valor, formatarDataApi(b.dataPagamento), this.arquivoBaixa)
      .subscribe(res => {
        this.snackBar.open('Baixa registrada. Situação: Recebido.', 'Sucesso', { duration: 2500 });
        this.formulario.patchValue({
          situacao: res.situacao,
          dtPagamento: res.dtRecebimento || res.dtPagamento,
          pagamento: res.pagamento,
        });
        this.valorBaixa = res.valorBaixa ?? res.total;
        this.atualizarMetadadosAnexos(res);
        this.arquivoBaixa = null;
        this.nomeArquivoBaixaSelecionado = '';
      }, err => this.snackBar.open(err.error?.message ?? 'Erro na baixa.', 'ERRO', { duration: 3000 }));
  }

  anexarFaturaConta() {
    const id = this.formulario.value.id;
    if (!id || !this.arquivoFatura) { return; }
    this.contaReceberService.anexarFatura(id, this.arquivoFatura).subscribe(res => {
      this.snackBar.open('Fatura anexada!', 'Sucesso', { duration: 2000 });
      this.atualizarMetadadosAnexos(res);
      this.arquivoFatura = null;
      this.nomeArquivoFaturaSelecionado = '';
    }, err => this.snackBar.open(err.error?.message ?? 'Erro ao anexar.', 'ERRO', { duration: 3000 }));
  }

  baixarAnexo(tipo: 'fatura' | 'baixa') {
    const id = this.formulario.value.id;
    if (!id) { return; }
    this.contaReceberService.downloadAnexo(id, tipo).subscribe(blob => {
      const nome = (tipo === 'fatura' ? this.nomeArquivoFaturaSalvo : this.nomeArquivoBaixaSalvo) || 'arquivo.pdf';
      abrirAnexoVisualizar(this.dialog, blob, nome);
    });
  }

  atualizarMetadadosAnexos(conta: ContaReceber) {
    this.patchDadosCobranca(conta);
    this.possuiAnexoFatura = !!conta.possuiAnexoFatura;
    this.possuiAnexoBaixa = !!conta.possuiAnexoBaixa;
    this.nomeArquivoFaturaSalvo = conta.nomeArquivoFatura || '';
    this.nomeArquivoBaixaSalvo = conta.nomeArquivoBaixa || '';
    this.valorBaixa = conta.valorBaixa ?? null;
    this.situacaoDescricaoAtual = conta.situacaoDescricao || '';
    this.statusPagamento = labelStatusPagamento(conta.situacao, this.situacaoDescricaoAtual, this.config);
    this.atualizarResumoFinanceiro();
  }

  copiarPix(copiaCola: string) {
    if (!copiaCola) { return; }
    navigator.clipboard.writeText(copiaCola);
    this.snackBar.open('PIX copia e cola copiado.', 'OK', { duration: 2000 });
  }

  baixarBolepix() {
    const id = this.formulario.value.id;
    if (!id) { return; }
    this.contaReceberService.downloadBolepix(id).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `bolepix-${id}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    }, () => this.snackBar.open('Erro ao gerar Bolepix.', 'ERRO', { duration: 3000 }));
  }

  baixarComprovantePix() {
    const id = this.formulario.value.id;
    if (!id) { return; }
    this.contaReceberService.downloadComprovantePix(id).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `comprovante-pix-${id}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
      this.possuiAnexoBaixa = true;
    }, () => this.snackBar.open('Erro ao gerar comprovante PIX.', 'ERRO', { duration: 3000 }));
  }

}